import { StartFreeButton } from "./MarketingButton";

type FinalCtaProps = {
  title: string;
  body: string;
  cta?: string;
};

export default function FinalCta({
  title,
  body,
  cta = "Start free",
}: FinalCtaProps) {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(135deg,#091240,#050923)] px-[6vw] py-[95px] text-center text-white before:absolute before:-inset-20 before:content-[''] before:[background:radial-gradient(circle_at_20%_50%,rgba(59,76,255,0.4),transparent_28%),radial-gradient(circle_at_80%_30%,rgba(99,209,157,0.16),transparent_22%)] max-[680px]:px-5 max-[680px]:py-[76px]">
      <div className="relative">
        <h2 className="mx-auto mb-6 max-w-[900px] font-figtree text-[clamp(40px,5vw,67px)] font-black uppercase leading-none tracking-[-0.05em]">
          {title}
        </h2>
        <p className="mx-auto mb-[30px] max-w-[650px] font-open-sans text-[19px] leading-[1.55] text-white/[0.72]">
          {body}
        </p>
        <StartFreeButton>{cta}</StartFreeButton>
      </div>
    </section>
  );
}
